/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Breakdown_Kind_Nightly_RateInputs */

const en_price_breakdown_kind_nightly_rate = /** @type {(inputs: Price_Breakdown_Kind_Nightly_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nightly rate`)
};

/**
* | output |
* | --- |
* | "Nightly rate" |
*
* @param {Price_Breakdown_Kind_Nightly_RateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_kind_nightly_rate = /** @type {((inputs?: Price_Breakdown_Kind_Nightly_RateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Kind_Nightly_RateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_kind_nightly_rate(inputs)
});